/**
 * Accessible Headers - Adjusts heading hierarchy within ignite-modules
 * 
 * This function ensures proper heading hierarchy by:
 * 1. Checking if there's an h1 tag within ignite-modules
 * 2. If no h1 exists, converts the first h2 to h1
 * 3. Then converts the first h3 to h2
 * 
 * This helps maintain proper document structure for screen readers and SEO
 */

function adjustHeadingHierarchy() {
    console.log('adjustHeadingHierarchy');
    const igniteModules = document.querySelector('.ignite-modules');
    
    if (!igniteModules) {
        console.warn('ignite-modules container not found');
        return;
    }

    // Check if there's already an h1 within ignite-modules
    const existingH1 = igniteModules.querySelector('h1');
    
    if (existingH1) {
        console.log('H1 found, no adjustment needed');
        return;
    }

    // Find the first h2 and convert it to h1
    const firstH2 = igniteModules.querySelector('h2');
    if (firstH2) {
        const h1Element = document.createElement('h1');
        
        // Copy all attributes from h2 to h1
        Array.from(firstH2.attributes).forEach(attr => {
            h1Element.setAttribute(attr.name, attr.value);
        });
        
        // Copy the content
        h1Element.innerHTML = firstH2.innerHTML;
        
        // Replace h2 with h1
        firstH2.parentNode.replaceChild(h1Element, firstH2);
        
        console.log('Converted first h2 to h1');
    }

    // Find the first h3 and convert it to h2
    const firstH3 = igniteModules.querySelector('h3');
    if (firstH3) {
        const h2Element = document.createElement('h2');
        
        // Copy all attributes from h3 to h2
        Array.from(firstH3.attributes).forEach(attr => {
            h2Element.setAttribute(attr.name, attr.value);
        });
        
        // Copy the content
        h2Element.innerHTML = firstH3.innerHTML;
        
        // Replace h3 with h2
        firstH3.parentNode.replaceChild(h2Element, firstH3);
        
        console.log('Converted first h3 to h2');
    }
}

// Run the function when DOM is loaded
document.addEventListener('DOMContentLoaded', adjustHeadingHierarchy);

// Also run it after a short delay to catch dynamically loaded content
setTimeout(adjustHeadingHierarchy, 100);

// Export for potential manual triggering
export default adjustHeadingHierarchy;